import type { Stage } from '@simplyanvil/cl-types';

// local runs against the dev API, so it sees what dev sees. Unknown values fail closed to prod.
export const currentStage = (): Stage => {
  const stage = process.env.NEXT_PUBLIC_STAGE;
  if (stage === 'dev' || stage === 'local') return 'dev';
  if (stage === 'uat') return 'uat';
  return 'prod';
};
